import React, { useState, useEffect, useRef } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { userStore } from "./store";
import MainRoutes from "./routes/Routes";
import PropTypes from "prop-types";
import ReactGA from "react-ga";

import Widget from "./components/Widget";
import store from "./store/store";
import SimpleForm from "./components/Widget/chatbot";

//import { connect } from 'http2';

//Connect React to Redux
// const Main = () => (
//   <Provider store={userStore}>
//     <MainRoutes />
//   </Provider>);
//vjvj

function Main() {
  const [loading, setLoading] = useState(true);
  const chatbotelement = useRef(undefined);
  const [adminInfo, setadminInfo] = useState(
    JSON.parse(localStorage.getItem("adminInfo"))
  );
  const [userInfo, setuserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  useEffect(() => {
    // initializeReactGA();
    setadminInfo(JSON.parse(localStorage.getItem("adminInfo")));
    setuserInfo(JSON.parse(localStorage.getItem("userInfo")));
    if(window.location.pathname.includes('admin') || window.location.pathname.includes('tp')){
      setLoading(false)
    }
    if(loading && !userInfo && !adminInfo){
      // chatbotelement.current.click()
    }
  });
  return (
    <Provider store={userStore}>
      <MainRoutes />
      {loading && !userInfo && !adminInfo && <SimpleForm ref={chatbotelement} />}
    </Provider>
  );
}

function initializeReactGA() {
  ReactGA.initialize("UA-173159305-1");
  ReactGA.pageview(window.location.pathname + window.location.search);
}

const ConnectedWidget = (props) => (
  <Provider store={store}>
    <Widget
      title={props.title}
      titleAvatar={props.titleAvatar}
      subtitle={props.subtitle}
      // handleNewUserMessage={props.handleNewUserMessage}
      // handleQuickButtonClicked={props.handleQuickButtonClicked}
      senderPlaceHolder={props.senderPlaceHolder}
      profileAvatar={props.profileAvatar}
      showCloseButton={props.showCloseButton}
      fullScreenMode={props.fullScreenMode}
      badge={props.badge}
      autofocus={props.autofocus}
      customLauncher={props.launcher}
    />
  </Provider>
);

ConnectedWidget.propTypes = {
  title: PropTypes.string,
  titleAvatar: PropTypes.string,
  subtitle: PropTypes.string,
  // handleNewUserMessage: PropTypes.func,
  //handleQuickButtonClicked: PropTypes.func,
  senderPlaceHolder: PropTypes.string,
  profileAvatar: PropTypes.string,
  showCloseButton: PropTypes.bool,
  fullScreenMode: PropTypes.bool,
  badge: PropTypes.number,
  autofocus: PropTypes.bool,
  launcher: PropTypes.func,
};

ConnectedWidget.defaultProps = {
  title: "NEED A HELP ?",
  // subtitle: 'Phone: +91 22 62458585',
  subtitle: "BIGFM SUPPORT CALL:",
  senderPlaceHolder: "Type a message...",
  showCloseButton: true,
  fullScreenMode: false,
  badge: 0,
  autofocus: true,
};

/** * Render main function that render dom element * inside the body which have id as app */
render(<Main />, document.getElementById("app"));

// useEffect(
//   () => {
//     let timer1 = setTimeout(() => setWidget(true), 30000)
//     return () => {
//       clearTimeout(timer1)
//     }
//   },
//   []
// )

// setTimeout = () => {
//  Widget = Widget.setTimeout(() => {}, 3000);
// };

// React.useEffect(() => {
//     let timer = setTimeout(() => ConnectedWidget(true), 3000);
//     return () => {
//       clearTimeout(timer)
//     }
//   },
//   [] )

{
  /* setTimeout(() => {

    console.log("hello")
    // <ConnectedWidget/>,
    // alert("hi")

  }, 60000); */
}

// export default function ConnectedWidget()
//   {
//   const [showConnectedWidget, setshowConnectedWidget] = useState(false)
//   useEffect(
//   () => {
//     let timer1 = setTimeout(() => setshowConnectedWidget(true), 30000)
//     return () => {
//       clearTimeout(timer1)
//     }
//   },
//   []
// )
// return  setshowConnectedWidget  && <div></div>
// }



// WEBPACK FOOTER //
// ./web/index.jsx